module.exports = __webpack_public_path__ + "static/media/lottomatica-logo.5bd9cd3e.svg";